<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:17:48
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 11:06:00
-->
<template>
    <div>
        <div class="top">
            <div @click="callback" style="font-size: 18px;font-weight: bold;">
                <a-icon class="icon-box" type="arrow-left" />&nbsp;
                <span >{{title}}</span> 
            </div>
            <el-button size="medium" v-repeatClick type="primary" @click="saveTemplateData">保存</el-button>
        </div>
        <div class="content">
            <div class="file-path">
                <div>文件路径: {{directoryPath}}</div>
                <div style="margin-left:30px">
                    文件名称:&nbsp;
                    <a-input style="width:170px;" :disabled="!!fileName" v-model="fileName" placeholder="文件名称" />
                </div>
            </div>
          <pre>
            <code :style="{height:height,display:'block'}" class="file-content" contenteditable spellcheck="false">{{fileInfoData}}</code>
          </pre>
          <!--                <el-input type="textarea" resize="none" :autosize="{ minRows: 20}" placeholder="请输入内容" v-model="fileInfoData">-->
          <!--                </el-input>-->
        </div>
    </div>
</template>

<script>
import {fileInfo,saveTemplate} from './template_management.js';
import hljs from 'highlight.js'
import javascript from 'highlight.js/lib/languages/javascript'
import css from 'highlight.js/lib/languages/css'
import 'highlight.js/styles/github-dark.css'
import { message } from 'ant-design-vue';

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('css', css)
export default {
    data(){
        return{
            fileName:'',
            directoryPath:'',
            allPath:'',
            fileInfoData:'',
            title:'',
            height:'',
          loading:false
        }
    },
    mounted(){
        this.directoryPath = this.$route.query.directoryPath
        this.allPath = this.$route.query.path
        this.fileName = this.$route.query.fileName
        this.title = this.$route.query.title
        if(this.title=='修改文件'){
            this.getFileInfo()
        }
         this.height = document.documentElement.clientHeight - 350 + 'px';
           window.onresize = () => {
              return (() => {
                 this.height = document.documentElement.clientHeight - 350 +'px';
              })();
    }
    },
    methods:{
        callback(){
            this.$router.push({
                path: "/index/configure/template_management",
            });
        },
        getFileInfo(){
            const _this = this
            fileInfo({path:_this.allPath}).then(res=>{
                if(res.code == 0){
                    _this.fileInfoData = res.data.data
                    const loading = this.$loading({
                      lock:true,
                      target:"pre"
                    })
                    this.$nextTick(()=>{
                      hljs.highlightElement(document.querySelector("code"));
                      loading.close();
                    })
                }
            })
        },
        saveTemplateData(){
            const _this = this
            if(!_this.fileName){
                message.error('请填写文件名')
                return
            }
            let code = document.querySelector("code");
            let reqData = {
                fileName:_this.fileName,
                note:code.innerText,
                path:_this.allPath?_this.allPath:_this.directoryPath
            }
            saveTemplate(reqData).then(res=>{
                if(res.code == 0){
                    message.success(res.msg)
                    this.callback()
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
[contenteditable]:focus{
  outline: 1px solid #4A90E2;
}
.top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 24px;
    border-bottom: solid #f4f4f6 2px;
    font-weight: bold;
}
.content{
    padding: 24px;
    .file-path{
        display: flex;
        align-items: center;
        background: #f5f5f5;
        border: solid #dadadd 1px;
        padding: 10px 20px;
        border-radius: 5px;
    }
    .file-content{
      width: calc(100% - 2px);
      margin: 20px auto 0;
      overflow-y: auto;
    }
}
.el-button--primary {
  background: #176de6;
}
.icon-box{
    cursor: pointer;
}
</style>